import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneyBestPlan = defineTemplate({
  mode: 'legacy',
  id: 'best-plan',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Tu mejor plan',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/tu_mejor_plan.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/tu_mejor_plan.png`,
    hoverVideo: `${BASE}/previews/tu_mejor_plan.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
